module.exports = __webpack_public_path__ + "static/media/fotogalereya6.043d1b4e.jpg";